import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    backgroundColor: (props) => (props.isSelected ? theme.palette.action.hover : 'transparent'),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  text: {
    fontSize: '14px',
    marginLeft: '6px',
  },
}));

export default function HistoryItem({ item, onSelect, isSelected }) {
  const classes = useStyles({ isSelected });

  return (
    <Box className={classes.itemContainer} px={4} py={2} onClick={onSelect}>
      <SearchIcon />
      <Typography className={classes.text}>{item}</Typography>
    </Box>
  );
}
